import DelBox from "../comps/DelBox";
import NewOrder1 from "../models/NewOrder1";
import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
function StorePurchase() {
    const [formData, setFormData] = useState({
        l1: [],
        store_purchase_type:'normal',
        suppliers: [] ,
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
    const [isAdmin , setIsAdmin] = useState('')
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
          const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('store_purchase_user', 1 + "");
            fd.append('store_purchase_type', formData.store_purchase_type);
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getStorePurchaseListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {

            }
        }


    };

     const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "supplier1");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("supplier : " + JSON.stringify(response))
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            suppliers: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('store_purchase_id', editItem.store_purchase_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                initData();
                toast.success("item deleted successfully")
            }
        } catch (error) {

        }
    };

    
    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const getVendorName = (id) => {
  const vendor = formData.suppliers.find((v) => v.user_id === id);
  if (!vendor) return id; // agar name na mile to id hi dikhado
  return vendor.fname + (vendor.lname ? " " + vendor.lname : "");
};


    return (
        <div class="page-content">
            <div class="container-fluid">
               

                <div class="row">
                    <div class="col-lg-12">
                        <div class="card" id="orderList">
                            <div class="card-header border-0">
                                <div class="row align-items-center gy-3">
                                    <div class="col-sm">
                                        <h5 class="card-title mb-0">Store Purchase</h5>
                                    </div>
                                    <div class="col-sm-auto">
                                        <div class="d-flex gap-1 flex-wrap">
                                            <a href="javascript:void(0)">
                                            <button type="button"
                                             onClick={(e) => {
                                                e.preventDefault();
                                                sessionStorage.removeItem("opd_dt");
                                                window.location.href = "/add_purchase";
                                            }}
                                            class="btn btn-success add-btn" ><i class="ri-add-line align-bottom me-1"></i> New Entry</button>
                                            </a>
                                            <button class="btn btn-soft-danger" id="remove-actions" onclick="deleteMultiple()"><i class="ri-delete-bin-2-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body border border-dashed border-end-0 border-start-0">
                                  <form>
                                    <div className="row g-3">
                                        
                                        <div className="col-md-2">
                                            <label className="form-label">From</label>
                                            <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">To</label>
                                            <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Search</label>
                                            <div className="search-box" style={{ display: "flex" }}>
                                                <button type="button" onClick={initData} className="btn btn-success">Search</button>
                                                &nbsp;&nbsp;&nbsp;
                                                <button type="button" onClick={() => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        search_key: "",
                                                        from: "",
                                                        to: "",
                                                    }));
                                                //   setResetTriggered(true); 
                                                }} className="btn btn-info">Clear</button>
                                            </div>
                                        </div>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3" style={{textAlign:"right"}}>
                                            <label className="form-label"></label>
                                            <div className="search-box">
                                                <input className="form-control search" placeholder="Search..." type="text"
                                                    name="search_key" onChange={handleChange} value={formData.search_key} />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />
                            <div class="card-body pt-0">
                                <div>

                                    <div class="table-responsive table-card mb-1">
                                        <table class="table table-nowrap align-middle" id="orderTable">
                                            <thead class="text-muted table-light" >
                                                <tr class="text-uppercase">
                                                    
                                                    <th data-sort="customer_name">SR No.</th>
                                                    <th data-sort="customer_name">Purchase No.</th>
                                                    <th data-sort="customer_name">Purchase date</th>
                                                    <th data-sort="customer_name">Supplier</th>
                                                    {/* <th data-sort="customer_name">Invoice No.</th> */}
                                                    {/* <th data-sort="customer_name">Invoice Date</th> */}
                                                    <th data-sort="customer_name">Total Amount</th>
                                                    <th data-sort="customer_name">Dis Amount</th>
                                                    <th data-sort="customer_name">Gst</th>
                                                    <th data-sort="customer_name">Action</th>
                                                </tr>
                                            </thead>
                                           <tbody class="list form-check-all">
  {formData.l1.map((item, index) => (
    <tr key={item.store_purchase_id}>
      <td class="customer_name">{index + 1}</td>
      <td class="customer_name">#{item.store_purchase_no}</td>
      <td class="customer_name">{item.store_purchase_date}</td>
      <td class="customer_name">{getVendorName(item.store_purchase_vendor)} </td>
      <td class="customer_name">{item.store_purchase_total}</td>
      <td class="customer_name">{item.store_purchase_dis}</td>
      <td class="customer_name">{item.store_purchase_gst}</td>

      {/* Delete Button Column */}
      <td class="customer_name">
        <button
          type="button"
          className="btn btn-danger btn-sm"
               disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
          onClick={() => {
              delItem(item);
            
          }}
        >
          <i className="ri-delete-bin-line"></i> Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>

                                           
                                        </table>
                                        {/* <div class="noresult">
                                            <div class="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                                <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="pagination-wrap hstack gap-2">
                                            <a class="page-item pagination-prev disabled" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.page_no > 0) {
                                                        formData.page_no--;
                                                        initData();
                                                    }
                                                }}
                                            >Previous</a>
                                            <ul class="pagination listjs-pagination mb-0"></ul>
                                            <a class="page-item pagination-next" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    formData.page_no++;
                                                    initData();
                                                }}
                                            >Next</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* <!--end col--> */}
                </div>
                {/* <!--end row--> */}

            </div>
            {/* <!-- container-fluid --> */}
        </div>
    );
}

export default StorePurchase;
